
export class ApiLibs {
    public static readonly getConfigs = '/api/v1/ext/metadata/configs-query';
    public static readonly getTridionResource = '/api/v1/ext/metadata/query-resource';
    public static readonly getCountryRegions = '/api/v1/ext/metadata/query-country-list';
    public static readonly getCountryCallCodes = '/api/v1/ext/metadata/query-sms-country-list';
    public static readonly getProvices = '/api/v1/ext/metadata/query-province';
    public static readonly validateVerify = '/api/v1/ext/validation/verify';
    public static readonly getCaptcha = '/api/v3/component/captcha';
    public static readonly verifyCaptcha = '/api/v3/component/verify';
    public static readonly sendPin = '/api/v1/ext/notification/send-pincode';
    public static readonly sendVoicePin = '/api/v1/ext/notification/send-voice-pin';
    public static readonly sendLoggedVoicePin = '/api/v1/ext/notification/send-voice-pin-logged';
    public static readonly verifyPin = '/api/v1/ext/notification/verify-pincode';
    public static readonly getPinExpireInfo = '/api/v1/ext/notification/query-pincode-expire-in';
    public static readonly loginPhonePin = '/api/v1/ext/guest/login-mobile-pin';
    public static readonly loginPhonePwd = '/api/v1/ext/guest/login-mobile-pwd';
    public static readonly loginEmailPwd = '/api/v1/ext/guest/login-email-pwd';
    public static readonly visitorLogin = '/api/v1/ext/guest/visitor-login';
    public static readonly completeInfo = '/api/v1/ext/account-operation/complete-info';
    public static readonly getUserInfo = '/api/v1/ext/account-query/web-account-base-info';
    public static readonly getWxUserInfo = '/api/v1/ext/account-query/wechat-account-base-info';
    public static readonly getAppUserInfo = '/api/v1/ext/account-query/app-account-base-info';
    public static readonly getAvatarImg = '/api/v1/ext/metadata/avatars/query-mobile-url';
    public static readonly getAvatars = '/api/v1/ext/metadata/query-avatars';
    public static readonly changeAvatar = '/api/v1/ext/account-operation/change-avatar';
    public static readonly changeName = '/api/v1/ext/account-operation/change-name';
    public static readonly setBirthday = '/api/v1/ext/account-operation/set-birthday';
    public static readonly changeRegion = '/api/v1/ext/account-operation/change-region';
    public static readonly changePreference = '/api/v1/ext/account-operation/change-preference';
    public static readonly checkPrePhone = '/api/v1/ext/account-operation/change-mobile-pre-check';
    public static readonly changePhone = '/api/v1/ext/account-operation/change-mobile';
    public static readonly changeEmail = '/api/v1/ext/account-operation/change-email';
    public static readonly verifyInviteCode = '/api/v1/ext/temp-account/verify-invite-code';
    public static readonly addPassword = '/api/v1/ext/account-operation/save-password';
    public static readonly changePassword = '/api/v1/ext/account-operation/change-password';
    public static readonly resetPassword = '/api/v1/ext/account-operation/reset-password';
    public static readonly doLogout = '/api/v1/ext/guest/logout';
    public static readonly doDeleteAcct = '/api/v1/ext/account-operation/unregister';
    public static readonly sendLoggedPin = '/api/v1/ext/notification/send-pincode-logged';
    public static readonly verifyLoggedPin = '/api/v1/ext/notification/verify-pincode-logged';
    public static readonly getLoggedPinExpireInfo = '/api/v1/ext/notification/query-pincode-expire-in-logged';
    public static readonly doAPCheck = '/api/v1/ext/ap/check';
    public static readonly doOaFansCheck = '/api/v1/ext/wechat/oa/followed';
    public static readonly getGenState = '/api/v1/ext/wechat/gen-state';
    public static readonly doDeleteGust = '/api/v1/ext/account-contact/delete';
    public static readonly getContactList = '/api/v1/ext/account-contact/query-page-list';
    public static readonly getSelectList = '/api/v1/ext/account-contact/selected-list'; 
    public static readonly saveContact = '/api/v1/ext/account-contact/save-selected';
    public static readonly getDict = '/api/v1/ext/account-contact/query-dict';
    public static readonly validateGID = '/api/v1/ext/validation/gid';
    public static readonly doSaveUpdate = '/api/v1/ext/account-contact/save-update';
    public static readonly getCarPlateList = '/api/v1/ext/car-plate/query'; 
    public static readonly delCarPlate = '/api/v1/ext/car-plate/delete'; 
    public static readonly editCarPlate = '/api/v1/ext/car-plate/update'; 
    public static readonly addCarPlate = '/api/v1/ext/car-plate/save'; 
    public static readonly wechatAuthLogin = '/api/v1/ext/guest/wechat/auth-login'; 
    public static readonly validateToken = '/api/v1/ext/token/validate';
}